"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DeviceDefinition = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_DeviceDefinition_UdiDeviceIdentifier_1 = require("./RTTI_DeviceDefinition_UdiDeviceIdentifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_DeviceDefinition_DeviceName_1 = require("./RTTI_DeviceDefinition_DeviceName");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_DeviceDefinition_Specialization_1 = require("./RTTI_DeviceDefinition_Specialization");
var RTTI_ProductShelfLife_1 = require("./RTTI_ProductShelfLife");
var RTTI_ProdCharacteristic_1 = require("./RTTI_ProdCharacteristic");
var RTTI_DeviceDefinition_Capability_1 = require("./RTTI_DeviceDefinition_Capability");
var RTTI_DeviceDefinition_Property_1 = require("./RTTI_DeviceDefinition_Property");
var RTTI_ContactPoint_1 = require("./RTTI_ContactPoint");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_DeviceDefinition_Material_1 = require("./RTTI_DeviceDefinition_Material");
exports.RTTI_DeviceDefinition = t.recursion('IDeviceDefinition', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('DeviceDefinition')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            udiDeviceIdentifier: t.array(RTTI_DeviceDefinition_UdiDeviceIdentifier_1.RTTI_DeviceDefinition_UdiDeviceIdentifier),
            manufacturerString: t.string,
            _manufacturerString: RTTI_Element_1.RTTI_Element,
            manufacturerReference: RTTI_Reference_1.RTTI_Reference,
            deviceName: t.array(RTTI_DeviceDefinition_DeviceName_1.RTTI_DeviceDefinition_DeviceName),
            modelNumber: t.string,
            _modelNumber: RTTI_Element_1.RTTI_Element,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            specialization: t.array(RTTI_DeviceDefinition_Specialization_1.RTTI_DeviceDefinition_Specialization),
            version: t.array(t.string),
            _version: t.array(RTTI_Element_1.RTTI_Element),
            safety: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            shelfLifeStorage: t.array(RTTI_ProductShelfLife_1.RTTI_ProductShelfLife),
            physicalCharacteristics: RTTI_ProdCharacteristic_1.RTTI_ProdCharacteristic,
            languageCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            capability: t.array(RTTI_DeviceDefinition_Capability_1.RTTI_DeviceDefinition_Capability),
            property: t.array(RTTI_DeviceDefinition_Property_1.RTTI_DeviceDefinition_Property),
            owner: RTTI_Reference_1.RTTI_Reference,
            contact: t.array(RTTI_ContactPoint_1.RTTI_ContactPoint),
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            onlineInformation: RTTI_uri_1.RTTI_uri,
            _onlineInformation: RTTI_Element_1.RTTI_Element,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            quantity: RTTI_Quantity_1.RTTI_Quantity,
            parentDevice: RTTI_Reference_1.RTTI_Reference,
            material: t.array(RTTI_DeviceDefinition_Material_1.RTTI_DeviceDefinition_Material)
        })
    ]);
});
//# sourceMappingURL=RTTI_DeviceDefinition.js.map